import { route } from '@/ziggy-shim';
import { api, CastValue } from './LaravelClient';

export default {
  async index(projectId: Id, data: ApiRequests['api.v1.projects.activity-log']) {
    return await api(route('api.v1.projects.activity-log', projectId), 'get', {
      data,
      casts: {
        log_name: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        log_level: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        user_id: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },
};
